import BaseApiClient from '../BaseApiClient';
import type {
  SavingsSingleClientViewParams,
  SavingsSingleClientViewResponse
} from '@/interfaces/SavingsSingleClientView.interface';

const API_VERSION = { Version: '2026-01-20' };

export class ApiSavingsSingleClientView extends BaseApiClient {
  async get(
    params: SavingsSingleClientViewParams
  ): Promise<SavingsSingleClientViewResponse> {
    const query = new URLSearchParams({
      bank_id: String(params.bank_id),
      end_date: params.end_date
    });

    if (params.page !== undefined)
      query.set('page[number]', String(params.page));
    if (params.perPage !== undefined)
      query.set('page[size]', String(params.perPage));

    const res = await this.client.get(
      `/single-client-view?${query.toString()}`,
      {
        headers: API_VERSION
      }
    );

    return res.data?.data ?? res.data;
  }
}

export * from './query-keys';
export * from './use-savings-single-client-view-queries';
